import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Accordion } from '@womcorp/wom-miwom-ui-kit/dist/components/Accordion';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import {
  FAQTitle,
  FAQContainer,
  AccordionSkeletonStyled,
  AccordionSkeletonContainer,
  AccordionSkeletonAnimationArrow,
} from './styles/FAQSectionStyled';
import { getFAQModelData } from '../../../services/Contentful';
import Title from '../../General/Title';

const richTextOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => {
      const {
        data: { uri = '' },
      } = node;
      const isLocalDomain = new RegExp('^(https?://)?([a-z]+-)?miwom.wom.cl');
      if (/^\//.test(uri) || isLocalDomain.test(uri)) {
        return <Link to={uri}>{children}</Link>;
      }
      return (
        <a href={uri} target="_blank" rel="noreferrer">
          {children}
        </a>
      );
    },
  },
};

const FAQSection = ({ section }) => {
  const skeleton = (
    <AccordionSkeletonContainer>
      <AccordionSkeletonStyled />
      <AccordionSkeletonAnimationArrow />
    </AccordionSkeletonContainer>
  );
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getFAQModelData(section)
      .then(res => {
        setQuestions(res[0].data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (!loading && questions && questions.length === 0) return <></>;

  return (
    <>
      {section === 'Ayuda' && <FAQTitle>Preguntas más visitadas</FAQTitle>}
      {section === 'Tienda' && (
        <Title text="PREGUNTAS MÁS VISITADAS" contrast="light" />
      )}
      <FAQContainer>
        {loading ? (
          <>{Array.from({ length: 5 }, () => skeleton)}</>
        ) : (
          questions.map(question => (
            <Accordion title={question.title}>
              {documentToReactComponents(question.body.json, richTextOptions)}
            </Accordion>
          ))
        )}
      </FAQContainer>
    </>
  );
};

FAQSection.propTypes = {
  section: PropTypes.string.isRequired,
};

export default FAQSection;
